<template>
  <div>
    <iframe class="print-iframe" ref="printIframe"></iframe>
    <div class="print-content" ref="printContent">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Print',
    props: {
      layout: {
        type: Number,
        default: 0
      }
    },
    methods: {
      print () {
        const iframeWindow = this.$refs.printIframe.contentWindow
        const printContent = this.$refs.printContent

        iframeWindow.document.head.innerHTML = document.head.innerHTML += `<style>@page { size: ${this.size}; margin-bottom: 0;}</style>`

        iframeWindow.document.body.innerHTML = `<div class="print-wrapper ${this.size}">` + printContent.innerHTML + '</div>'
        setTimeout(() => {
          iframeWindow.print()
        }, 0)
      }
    },
    computed: {
      size () {
        return this.layout ? 'landscape' : '21cm 29.7cm portrait'
      }
    }
  }
</script>

<style>
  /* .print-iframe {
    display: none;
  } */
</style>
